export function isWhitelisted(origin: string, whitelist: string[], isDev: boolean): boolean {
  if (whitelist.some((entry) => origin.startsWith(entry))) {
    return true;
  }
  return isDev;
}
